import Repository from './repository'

export default {
    get () {
        return Repository.get(`/api/s201-top-page/view`)
    }
}
